const users = {
  welcome: 'Welcome to Velocity',
  guides: 'Guides',
  share_feedback: 'Share feedback',
  share_feedback_description:
    'Send an email with your feedback to the following address:',
  agreements: {
    eula: 'End-User License Agreement ("Agreement")',
    privacy: 'Privacy Policy',
    email_opt_in: 'E-mail notifications',
  },
  email: 'Email',
  password: 'Password',
  password_confirmation: 'Password confirmation',
  name: 'Name',
  login: 'Username',
  go_back_to_sign_in: 'Go back to Sign In',
  auth: {
    sign_in: 'Sign in',
    sign_up: 'Sign up',
    sign_up_to_join: 'Sign up to join {{team}}',
    sign_out: 'Sign out',
    log_out: 'Log out',
    skip_for_now: 'Skip for now',
    or_sign_in_via: 'or sign in via',
    do_not_have_account_yet: "Don't have an account yet?",
    already_have_an_account: 'Already have an account?',
    new_here: 'New here?',
    email_placeholder: 'Your email address',
    password_placeholder: 'Your password',
    password_confirmation_placeholder: 'Your password confirmation',
    name_placeholder: 'Your name',
    login_placeholder: 'Your username',
    authenticating: 'Authenticating...',
    registering: 'Registering...',
    agreement:
      'I agree to the <eula>EULA</eula> & <privacy>Privacy Policy</privacy>',
    email_opt_in: 'Receive notifications about simulations',
    account_information: 'Account information',
    finish: 'Finish',
    account_created: 'Account successfully created',
    account_created_description:
      'Everything is set up and you are ready to go. Click the button below to proceed to the homepage.',
    account_created_plugin: 'Success!',
    account_created_description_plugin:
      'You now have an account with which to Sync your Assets. Click the button below to proceed.',
    success: 'Authorization successful',
    google_success: 'You can close this tab.',
    figma_success: 'You can close this tab.',
    failure: 'Authorization failed',
    google_failure:
      'Something went wrong during the Google sign in process. Please go back and try again.',
    figma_failure:
      'Something went wrong during the Figma sign in process. Please go back and try again.',
  },
  forgot_password: {
    title: 'Forgot password',
    check_your_email: 'Check your email',
    instructions_sent: "We've sent you an email with instructions.",
    email: 'Email',
    email_placeholder: 'Your email address',
    remembered_the_password: 'Remembered the password?',
    send_recovery_email: 'Send recovery mail',
  },
  reset_password: {
    title: 'Reset password',
    description: 'Write down your new password and confirm it.',
    success: 'Password has been reset successfully',
    success_message:
      'Everything is good, now you can sign in with the new password.',
    new_password: 'New password',
    new_password_placeholder: 'Your new password',
    confirm_new_password: 'Confirm new password',
    confirm_new_password_placeholder: 'Confirm new password',
    remembered_the_password: 'Remembered the password?',
    reset: 'Reset',
    resetting: 'Resetting password...',
  },
  update_password: {
    updating: 'Updating password...',
  },
  validation: {
    email_cannot_be_empty: "Email can't be empty",
    email_is_not_valid: 'Email is not valid',
    password_cannot_be_empty: "Password can't be empty",
    name_cannot_be_empty: "Name can't be empty",
    name_too_short: 'Name must have at least {{minLength}} characters',
    name_too_long: 'Name must be no longer than {{maxLength}} characters',
    password_too_short: 'Password must have at least {{minLength}} characters',
    password_too_weak:
      'Password must contain at least one lowercase letter, one uppercase letter, one digit and one special character.',
    password_confirmation_cannot_be_empty: 'You must confirm your new password',
    passwords_do_not_match: 'Passwords do not match',
    login_cannot_be_empty: "Username can't be empty",
    login_too_short: 'Username must have at least {{minLength}} characters',
    login_too_long: 'Username must be no longer than {{maxLength}} characters',
    login_is_not_valid:
      'Username is not valid, only letters and numbers are acceptable',
    agreement_is_necessary: 'You have to accept both contracts',
  },
  errors: {
    no_projects: 'You do not have any workspaces at the moment',
    invalid_credentials: 'Invalid credentials',
    not_authorized: 'You are not authorized to access this resource',
    not_found: 'The resource you are looking for does not exist',
    browser_auth_error:
      'Something went wrong during the browser authorization. Please retry by clicking the button below.',
    username_already_taken: 'This login is already taken.',
    email_already_taken: 'This email is already taken.',
    account_is_not_active: 'Account is deactivated',
  },
  username: {
    missing: 'Username is not set',
    missing_text_1:
      'It looks like your profile is missing some important information.',
    missing_text_2:
      'Please set the username first. It will be required later to authorize with registry.',
    label: 'Username',
    placeholder: 'Enter unique profile name',
  },
  menu: {
    profile: 'Profile',
    logout: 'Log Out',
    my_reports: 'Reports',
    compare: 'Compare A vs B',
    journey_heuristics: 'Journey Heuristics',
    websites: 'Websites',
    personas: 'Personas',
  },
  reports: {
    no_matching_reports: 'There are no reports matching your criteria.',
    count_one: '{{count}} report',
    count_other: '{{count}} reports',
    sections: {
      figma_prototypes: 'Figma',
      vibe_check_prototypes: 'Websites',
    },
    vibe_check: {
      empty: 'No Vibe Checks yet. Run a URL simulation to get started.',
    },
    filters: {
      title: 'Filter by:',
      owner: {
        title: 'Users',
        all: 'All reports',
        own: 'My reports',
      },
      file_name: {
        all: 'All files',
        title: 'File name',
      },
      page_name: {
        all: 'All pages',
        title: 'Page name',
      },
      flow_name: {
        all: 'All flows',
        title: 'Flow name',
      },
      url: {
        all: 'All URLs',
        title: 'URL',
      },
      product_category: {
        title: 'Product category',
        all: 'All categories',
        activation: 'Activation',
        retention: 'Retention',
        expansion: 'Expansion',
      },
      date: {
        title: 'Dates',
        all: 'All time',
        custom: 'Custom',
        last_24_hours: 'Last 24 hours',
        last_week: 'Last week',
        last_30_days: 'Last 30 days',
        last_6_months: 'Last 6 months',
        last_12_months: 'Last 12 months',
      },
    },
  },
  settings: {
    error_saving_user_data: 'Error saving user data',
    modal_header: 'User Profile',
    main_info: 'Main info',
    email_address: 'Email address',
    new_email: 'New email',
    change_photo: 'Change photo',
    change_email: 'Change email',
    change_email_placeholder: 'Enter new email address',
    change_email_instructions:
      'We’ll send an email to your new address with instructions on completing the change.',
    change_password: 'Change password',
    old_password: 'Old password',
    new_password: 'New password',
    confirm_password: 'Repeat new password',
    old_password_placeholder: 'Enter your current password',
    new_password_placeholder: 'Enter new password',
    confirm_password_placeholder: 'Enter new password once again',
    delete_profile: 'Delete profile',
    username: 'Username',
    full_name: 'Full name',
    your_full_name: 'Your full name',
    account: 'Account',
    profile: 'Profile',
    notifications: 'Notifications',
    billing: 'Billing',
    invoices: 'Invoices',
    settings: 'Settings',
    org_usage: 'Org usage',
  },
  org_usage: {
    title: 'Organization usage',
  },
  project_invitation: {
    success: {
      title: 'Invitation accepted',
      description:
        'You now have access to the {{projectName}} workspace and can start using it.',
      go_to_workspace: 'Go to workspace',
    },
    fail: {
      title: 'Invitation cannot be accepted',
      description:
        'Something went wrong while inviting you to the workspace. Please request another invitation for acceptance.',
      go_to_home_page: 'Go to home page',
    },
  },
  notifications_settings: {
    title: 'Email notifications',
    description: 'Control how you receive updates from us.',
  },
  pro_only: {
    title: 'Pro-only feature',
    description:
      'Upgrade to Pro to batch run x10, x50, or x100 for deeper insights.',
    label: 'Upgrade to Pro for {{price}}',
  },
  higher_plan_only: {
    title: 'Available on paid plans',
    description: 'Upgrade your plan to use this feature.',
    label: 'Upgrade',
  },
  contact_team_admin: {
    title: 'Contact your team owner',
    description:
      'Only the team owner can view and change the plan. Contact the person responsible for this team to see the options.',
  },
  no_more_credits: {
    title: 'You’ve hit the limit',
    description: 'You’ve used up out your current simulation allowance.',
    ask_owner: 'Contact the team owner to add more simulations to the plan.',
    upgrade: 'Upgrade your account',
    buy_pack: 'Buy simulations pack',
    label: 'Contact us',
  },
  notifications: {
    no_notifications: 'You have no notifications',
    title: 'Notifications',
    pending: 'Pending:',
    invitation:
      "You'are invited to join <tag>{{team}}</tag> as <tag>{{role}}</tag>.",
    new: 'You have a new notification!',
    new_invitation: 'You are invited to {{name}} team.',
  },
} as const;

export default users;
